import React, { useContext, useEffect, useState } from "react";
import { useRemote } from "../../Utils/Utils";
import { BannerContext } from "../../InternalApiApp";
import Page, { PageContentBodyGrid } from '../Shared/Page/Page';
import PageGridItem from '../Shared/Page/PageGridItem';
import LoadingIcon from "../../components/LoadingIcon";
import AnalyticsGenericTable from "./AnalyticsGenericTable";
import AnalyticsMetricsBanner from './AnalyticsMetricsBanner'
import './AnalyticsPage.scss'


const AnalyticsGenericList = ({ name, path, listData, individualPagePath }) => {
    const { setBannerBreadCrumbs } = useContext(BannerContext);

    const remote = useRemote()
    const [list, setList] = useState(null)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        setBannerBreadCrumbs({ tab: name })
        if (listData) {
            remote.get(listData?.dataEndPoint).then(fetchedData => {
                setList(fetchedData)
            }).then(() => setLoading(false))
        }
    }, [listData])


    return (
        <Page noBanner showScrollbar>
            <PageContentBodyGrid rowGap="xl" showScrollbar>
                <PageGridItem colSpan="12">
                    <AnalyticsMetricsBanner data={list} guidelines={listData?.metrics} loading={loading} style={{ paddingBottom: '1rem', gap: '3rem' }} />
                    {loading ? <LoadingIcon centered size={48} /> :
                        <AnalyticsGenericTable
                            searchable={listData.searchableBy}
                            title={listData.title}
                            tableStyle={{ maxWidth: 1200, minWidth: 900 }}
                            colWidths={listData.colWidths}
                            headers={listData.headers}
                            columns={listData.body}
                            data={list}
                            initialSort={listData.initialSort}
                            individualPagePath={individualPagePath}
                            searchPlaceholder={"Search " + name.toLowerCase() + " (" + list.length + ")"}
                        />
                    }
                </PageGridItem>
            </PageContentBodyGrid>
        </Page>
    );
}

export default AnalyticsGenericList;